import PatternValidatonRule from "features/validation/rules/PatternValidatonRule";
import { ExportDefinitionParametrDataType } from "features/exports/enums/exportDefinitionParametrDataType";
import FormExportParameterConfig from "./FormExportParameterConfig";
import { formatBool, formatDateTime, formatDecimal, formatEnumMulti } from "features/exports/helpers/exportFormHelper";

export const FormExportParametersMap: Record<
  ExportDefinitionParametrDataType,
  FormExportParameterConfig
> = {
  Bool: {
    type: "RadioBoxBool",
    outputFormat: formatBool
  },
  DateTime: {
    type: "DatePicker",
    outputFormat: formatDateTime
  },
  Decimal: {
    type: "TextBox",
    validation: {
      enableEmptyValue: true,
      type: "Pattern",
      regex: /^(\d+(?:[\.\,]\d{1,3})?)$/,
      message: "invalidThreeDecimalsNumber",
    } as PatternValidatonRule,
    outputFormat: formatDecimal,
  },
  Int: {
    type: "TextBox",
    validation: {
      enableEmptyValue: true,
      type: "Pattern",
      regex: /^\d+$/,
      message: "invalidInteger",
    } as PatternValidatonRule,
  },
  String: {
    type: "TextBox"
  },
  Enum: {
    type: "Select",
  },
  EnumMulti: {
    type: "SelectMultiple",
    outputFormat: formatEnumMulti
  },
};

